module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1014-953c7c96965b863d23b3add14974c306.png";